/* Matraws forside — reveal-on-scroll + count-up. Let, ingen dependencies. */
(function () {
  if (window.__mtwHome) return;
  window.__mtwHome = 1;

  function init() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* reveal */
    var els = document.querySelectorAll('.mtw-h [data-mtwr]');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
        });
      }, { threshold: .12, rootMargin: '0px 0px -8% 0px' });
      els.forEach(function (e) { io.observe(e); });
    }

    /* count-up på [data-count] */
    var nums = document.querySelectorAll('.mtw-h [data-count]');
    if (nums.length) {
      if (reduce || !('IntersectionObserver' in window)) {
        nums.forEach(function (n) { n.textContent = n.getAttribute('data-count'); });
      } else {
        var io2 = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (!en.isIntersecting) return;
            io2.unobserve(en.target);
            var el = en.target, target = parseInt(el.getAttribute('data-count'), 10) || 0, start = null;
            function step(ts) {
              if (!start) start = ts;
              var p = Math.min((ts - start) / 1100, 1);
              el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3)));
              if (p < 1) requestAnimationFrame(step);
            }
            requestAnimationFrame(step);
          });
        }, { threshold: .6 });
        nums.forEach(function (n) { io2.observe(n); });
      }
    }

    /* hero kort-vifte: parallax efter musen (kun fine pointer, ikke reduced-motion) */
    var fan = document.querySelector('[data-mtw-herofan]');
    if (fan && !fan.__mtwPx && !reduce && window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      fan.__mtwPx = 1;
      var hero = fan.closest('.mtw-hero') || fan.parentNode;
      hero.addEventListener('pointermove', function (e) {
        var r = hero.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
        fan.style.setProperty('--hx', ((px - 0.5) * 11).toFixed(2) + 'deg');
        fan.style.setProperty('--hy', ((0.5 - py) * 7).toFixed(2) + 'deg');
      });
      hero.addEventListener('pointerleave', function () {
        fan.style.setProperty('--hx', '0deg');
        fan.style.setProperty('--hy', '0deg');
      });
    }

    /* pakke-åbning: desktop = åbn ved hover, touch/reduced = åbn når i view (staggered) */
    var games = document.querySelectorAll('.mtw-h .mtw-game');
    if (games.length) {
      var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      if (fine && !reduce) {
        games.forEach(function (g) {
          if (g.__mtwPack) return; g.__mtwPack = 1;
          g.addEventListener('mouseenter', function () { g.classList.add('is-open'); });
          g.addEventListener('mouseleave', function () { g.classList.remove('is-open'); });
        });
      } else if (reduce || !('IntersectionObserver' in window)) {
        games.forEach(function (g) { g.classList.add('is-open'); });
      } else {
        var ioG = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { en.target.classList.add('is-open'); ioG.unobserve(en.target); }
          });
        }, { threshold: .35 });
        games.forEach(function (g) { ioG.observe(g); });
      }
    }

    /* reels: autoplay-in-view (muted/loop) + lyd-toggle pr. kort */
    var reels = document.querySelectorAll('.mtw-h [data-mtw-reels] .mtw-reel');
    if (reels.length) {
      reels.forEach(function (reel) {
        if (reel.__mtwReel) return; reel.__mtwReel = 1;
        var vid = reel.querySelector('.mtw-reel-video');
        if (vid) {
          vid.muted = true; vid.loop = true; vid.setAttribute('playsinline', ''); vid.setAttribute('webkit-playsinline', '');
        }
        var sound = reel.querySelector('[data-mtw-sound]');
        if (sound && vid) {
          sound.addEventListener('click', function (e) {
            e.preventDefault(); e.stopPropagation();
            // sluk lyd på alle andre reels
            reels.forEach(function (other) {
              if (other === reel) return;
              var ov = other.querySelector('.mtw-reel-video');
              if (ov) { ov.muted = true; }
              other.classList.remove('is-unmuted');
            });
            vid.muted = !vid.muted;
            reel.classList.toggle('is-unmuted', !vid.muted);
            if (!vid.muted) { var p = vid.play(); if (p && p.catch) p.catch(function () {}); }
          });
        }
      });
      if (!reduce && 'IntersectionObserver' in window) {
        var ioR = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var v = en.target.querySelector('.mtw-reel-video');
            if (!v) return;
            if (en.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
            else { v.pause(); }
          });
        }, { threshold: .4 });
        reels.forEach(function (reel) { ioR.observe(reel); });
      }

      /* reels: fuldskærms-viewer (Instagram-style, swipe mellem) */
      var fsItems = [];
      reels.forEach(function (reel) {
        var v = reel.querySelector('.mtw-reel-video');
        if (!v) return;
        var srcs = [];
        v.querySelectorAll('source').forEach(function (s) { srcs.push({ src: s.getAttribute('src'), type: s.getAttribute('type') || '' }); });
        if (!srcs.length && v.currentSrc) srcs.push({ src: v.currentSrc, type: '' });
        var prod = reel.querySelector('.mtw-reel-prod');
        reel.__mtwFs = fsItems.length;
        fsItems.push({ reel: reel, srcs: srcs, poster: v.getAttribute('poster') || '', prod: prod ? prod.outerHTML : '' });
      });

      if (fsItems.length) {
        var ov = document.createElement('div');
        ov.className = 'mtw-reelfs'; ov.setAttribute('hidden', '');
        var sndOff = '<svg class="icon-off" width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M11 5 6 9H3v6h3l5 4V5Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="m16 9 5 6M21 9l-5 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
        var sndOn = '<svg class="icon-on" width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M11 5 6 9H3v6h3l5 4V5Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M16 8.5a4 4 0 0 1 0 7M18.5 6a7.5 7.5 0 0 1 0 12" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
        ov.innerHTML =
          '<div class="mtw-reelfs-bg" data-close></div>' +
          '<button type="button" class="mtw-reelfs-x" data-close aria-label="Luk"><svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M6 6l12 12M18 6 6 18" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg></button>' +
          '<button type="button" class="mtw-reelfs-nav prev" data-prev aria-label="Forrige"><svg width="26" height="26" viewBox="0 0 24 24" fill="none"><path d="M15 6l-6 6 6 6" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
          '<button type="button" class="mtw-reelfs-nav next" data-next aria-label="Næste"><svg width="26" height="26" viewBox="0 0 24 24" fill="none"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
          '<div class="mtw-reelfs-stage">' +
            '<video class="mtw-reelfs-video" playsinline webkit-playsinline loop></video>' +
            '<button type="button" class="mtw-reelfs-play" data-playpause aria-label="Afspil/pause"><span class="mtw-reelfs-playic" aria-hidden="true"><svg width="30" height="30" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7L8 5Z"/></svg></span></button>' +
            '<button type="button" class="mtw-reelfs-sound" data-sound aria-label="Lyd til/fra">' + sndOff + sndOn + '</button>' +
            '<div class="mtw-reelfs-prod" data-prod></div>' +
          '</div>' +
          '<div class="mtw-reelfs-dots" data-dots></div>';
        document.body.appendChild(ov);

        var fsVid = ov.querySelector('.mtw-reelfs-video');
        var fsProd = ov.querySelector('[data-prod]');
        var fsDots = ov.querySelector('[data-dots]');
        var cur = -1;
        fsItems.forEach(function () { fsDots.appendChild(document.createElement('span')); });

        function fsSyncSound() { ov.classList.toggle('is-muted', fsVid.muted); }
        function fsShow(i) {
          if (i < 0) i = fsItems.length - 1; if (i >= fsItems.length) i = 0;
          cur = i; var it = fsItems[i];
          while (fsVid.firstChild) fsVid.removeChild(fsVid.firstChild);
          it.srcs.forEach(function (s) { var el = document.createElement('source'); el.src = s.src; if (s.type) el.type = s.type; fsVid.appendChild(el); });
          if (it.poster) fsVid.poster = it.poster; else fsVid.removeAttribute('poster');
          fsVid.muted = false; fsVid.load();
          var p = fsVid.play(); if (p && p.catch) p.catch(function () { fsVid.muted = true; var p2 = fsVid.play(); if (p2 && p2.catch) p2.catch(function () {}); fsSyncSound(); });
          fsProd.innerHTML = it.prod || '';
          for (var k = 0; k < fsDots.children.length; k++) fsDots.children[k].className = (k === i ? 'is-on' : '');
          fsSyncSound();
        }
        function fsOpen(i) {
          reels.forEach(function (r) { var rv = r.querySelector('.mtw-reel-video'); if (rv) rv.pause(); });
          ov.removeAttribute('hidden');
          document.documentElement.classList.add('mtw-reelfs-lock');
          requestAnimationFrame(function () { ov.classList.add('is-open'); });
          fsShow(i);
        }
        function fsClose() {
          ov.classList.remove('is-open'); fsVid.pause();
          document.documentElement.classList.remove('mtw-reelfs-lock');
          setTimeout(function () { ov.setAttribute('hidden', ''); while (fsVid.firstChild) fsVid.removeChild(fsVid.firstChild); }, 260);
        }

        reels.forEach(function (reel) {
          var media = reel.querySelector('.mtw-reel-media');
          if (!media) return;
          media.addEventListener('click', function (e) {
            if (e.target.closest('[data-mtw-sound], .mtw-reel-prod')) return;
            e.preventDefault(); fsOpen(reel.__mtwFs);
          });
        });

        ov.addEventListener('click', function (e) {
          if (e.target.closest('[data-close]')) { fsClose(); return; }
          if (e.target.closest('[data-prev]')) { fsShow(cur - 1); return; }
          if (e.target.closest('[data-next]')) { fsShow(cur + 1); return; }
          if (e.target.closest('[data-sound]')) { fsVid.muted = !fsVid.muted; if (!fsVid.muted) { var p = fsVid.play(); if (p && p.catch) p.catch(function () {}); } fsSyncSound(); return; }
          if (e.target.closest('[data-playpause]')) { if (fsVid.paused) fsVid.play(); else fsVid.pause(); return; }
        });
        fsVid.addEventListener('play', function () { ov.classList.remove('is-paused'); });
        fsVid.addEventListener('pause', function () { ov.classList.add('is-paused'); });

        document.addEventListener('keydown', function (e) {
          if (ov.hasAttribute('hidden')) return;
          if (e.key === 'Escape') fsClose();
          else if (e.key === 'ArrowRight' || e.key === 'ArrowUp') fsShow(cur + 1);
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') fsShow(cur - 1);
        });

        var tsx = 0, tsy = 0, tst = 0;
        ov.addEventListener('touchstart', function (e) { var t = e.changedTouches[0]; tsx = t.clientX; tsy = t.clientY; tst = Date.now(); }, { passive: true });
        ov.addEventListener('touchend', function (e) {
          var t = e.changedTouches[0], dx = t.clientX - tsx, dy = t.clientY - tsy;
          if (Date.now() - tst > 600) return;
          if (Math.abs(dx) > Math.abs(dy)) {
            if (dx < -45) fsShow(cur + 1); else if (dx > 45) fsShow(cur - 1);
          } else if (dy > 90) { fsClose(); }
        }, { passive: true });
      }
    }

    /* populære kort: fane-skift (crossfade) + rail-pile */
    /* tving lazy-billeder til at loade når en (tidligere display:none) fane vises */
    function mtwUnveilLazy(scope) {
      if (!scope) return;
      var ls = window.lazySizes;
      scope.querySelectorAll('img.lazyload').forEach(function (img) {
        try { if (ls && ls.loader && ls.loader.unveil) { ls.loader.unveil(img); return; } } catch (e) {}
        var u = img.getAttribute('data-original') || img.getAttribute('data-src') || '';
        if (u && u.indexOf('{width}') === -1) { img.src = u; }
        img.classList.remove('lazyload'); img.classList.add('lazyloaded');
      });
      scope.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
      try { window.dispatchEvent(new Event('resize')); } catch (e) {}
    }

    var tabGrids = document.querySelectorAll('.mtw-h .mtw-tabs-grid');
    tabGrids.forEach(function (grid) {
      if (grid.__mtwTabs) return; grid.__mtwTabs = 1;
      var tabs = grid.querySelectorAll('[data-mtw-tab]');
      var panels = grid.querySelectorAll('[data-mtw-panel]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var idx = tab.getAttribute('data-mtw-tab');
          tabs.forEach(function (t) {
            var on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          panels.forEach(function (p) {
            var on = p.getAttribute('data-mtw-panel') === idx;
            if (on) {
              p.hidden = false;
              p.classList.add('is-active', 'is-entering');
              mtwUnveilLazy(p);
              setTimeout(function () { p.classList.remove('is-entering'); }, 650);
            } else {
              p.hidden = true;
              p.classList.remove('is-active');
            }
          });
        });
      });
      grid.querySelectorAll('[data-mtw-rail-prev], [data-mtw-rail-next]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var panel = btn.closest('[data-mtw-panel]');
          var rail = panel && panel.querySelector('[data-mtw-rail]');
          if (!rail) return;
          var card = rail.querySelector('.product-card-item');
          var step = card ? card.getBoundingClientRect().width + 16 : 300;
          rail.scrollBy({ left: btn.hasAttribute('data-mtw-rail-next') ? step : -step, behavior: 'smooth' });
        });
      });
    });

    /* nyheder/produkt-slider: pile (erstatter scrollbar) */
    document.querySelectorAll('.mtw-h .mtw-feat-railwrap').forEach(function (wrap) {
      if (wrap.__mtwFeat) return; wrap.__mtwFeat = 1;
      var rail = wrap.querySelector('[data-mtw-feat-rail]');
      if (!rail) return;
      function upd() {
        var max = rail.scrollWidth - rail.clientWidth;
        var noScroll = max <= 2;
        wrap.querySelectorAll('[data-mtw-feat-prev]').forEach(function (b) { b.classList.toggle('is-hidden', noScroll || rail.scrollLeft <= 2); });
        wrap.querySelectorAll('[data-mtw-feat-next]').forEach(function (b) { b.classList.toggle('is-hidden', noScroll || rail.scrollLeft >= max - 2); });
      }
      wrap.querySelectorAll('[data-mtw-feat-prev], [data-mtw-feat-next]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var card = rail.querySelector('.product-card-item');
          var step = card ? card.getBoundingClientRect().width + 16 : rail.clientWidth * 0.8;
          rail.scrollBy({ left: btn.hasAttribute('data-mtw-feat-next') ? step : -step, behavior: 'smooth' });
        });
      });
      rail.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    });

    /* hero predictive search — live forslag mens du skriver (Shopify suggest API) */
    initHeroSearch();
  }

  function initHeroSearch() {
    var boxes = document.querySelectorAll('.mtw-hero-search');
    if (!boxes.length) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    function fmtPrice(p) {
      var n = Math.round(parseFloat(p) || 0);
      try { return n.toLocaleString('da-DK') + ' kr'; } catch (e) { return n + ' kr'; }
    }

    boxes.forEach(function (box) {
      if (box.__mtwPredict) return; box.__mtwPredict = 1;
      var form = box.querySelector('form');
      var input = box.querySelector('input[name="q"]');
      if (!form || !input) return;

      var dd = document.createElement('div');
      dd.className = 'mtw-hsr';
      dd.setAttribute('hidden', '');
      box.appendChild(dd);

      var sel = -1, items = [], term = '', timer = null, reqId = 0;

      function close() { dd.setAttribute('hidden', ''); sel = -1; }
      function open() { dd.removeAttribute('hidden'); }

      function allLink(t) {
        return root.replace(/\/$/, '') + '/search?q=' + encodeURIComponent(t) + '&type=product';
      }

      function render(products) {
        items = [];
        if (!products.length) {
          dd.innerHTML = '<div class="mtw-hsr-empty">Ingen forslag — tryk Enter for at søge på “' + term.replace(/</g, '') + '”.</div>';
          open(); return;
        }
        var html = '<div class="mtw-hsr-list">';
        products.forEach(function (p) {
          var img = (p.featured_image && p.featured_image.url) || p.image || '';
          var price = (p.price_min && p.price_max && p.price_min !== p.price_max)
            ? 'Fra ' + fmtPrice(p.price_min) : fmtPrice(p.price);
          html += '<a class="mtw-hsr-item" href="' + p.url + '">'
            + '<span class="mtw-hsr-thumb">' + (img ? '<img src="' + img + '&width=120" alt="" loading="lazy">' : '') + '</span>'
            + '<span class="mtw-hsr-info"><span class="mtw-hsr-title">' + p.title + '</span>'
            + '<span class="mtw-hsr-price">' + price + (p.available ? '' : ' · Udsolgt') + '</span></span>'
            + '<span class="mtw-hsr-go" aria-hidden="true">→</span></a>';
        });
        html += '</div><a class="mtw-hsr-all" href="' + allLink(term) + '">Se alle resultater for “' + term.replace(/</g, '') + '” →</a>';
        dd.innerHTML = html;
        items = Array.prototype.slice.call(dd.querySelectorAll('.mtw-hsr-item, .mtw-hsr-all'));
        open();
      }

      function fetchSuggest(t) {
        var my = ++reqId;
        var url = root.replace(/\/$/, '') + '/search/suggest.json?q=' + encodeURIComponent(t)
          + '&resources[type]=product&resources[limit]=6'
          + '&resources[options][fields]=title,product_type,variants.title,vendor,tag';
        fetch(url, { headers: { 'Accept': 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
          .then(function (d) {
            if (my !== reqId) return;
            var prods = (d && d.resources && d.resources.results && d.resources.results.products) || [];
            render(prods);
          })
          .catch(function (err) {
            if (my !== reqId) return;
            try { console.warn('[mtw hero search]', err); } catch (e) {}
            dd.innerHTML = '<a class="mtw-hsr-all" href="' + allLink(t) + '">Søg efter “' + t.replace(/</g, '') + '” →</a>';
            open();
          });
      }

      input.addEventListener('input', function () {
        term = input.value.trim();
        clearTimeout(timer);
        if (term.length < 2) { close(); return; }
        dd.innerHTML = '<div class="mtw-hsr-loading">Søger…</div>'; open();
        timer = setTimeout(function () { fetchSuggest(term); }, 170);
      });

      input.addEventListener('keydown', function (e) {
        if (dd.hasAttribute('hidden') || !items.length) return;
        if (e.key === 'ArrowDown') { e.preventDefault(); sel = (sel + 1) % items.length; }
        else if (e.key === 'ArrowUp') { e.preventDefault(); sel = (sel - 1 + items.length) % items.length; }
        else if (e.key === 'Enter') { if (sel >= 0) { e.preventDefault(); items[sel].click(); return; } }
        else if (e.key === 'Escape') { close(); return; }
        else return;
        items.forEach(function (el, i) { el.classList.toggle('is-sel', i === sel); });
      });

      input.addEventListener('focus', function () { if (term.length >= 2 && dd.innerHTML) open(); });
      document.addEventListener('click', function (e) { if (!box.contains(e.target)) close(); });
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function () { window.__mtwHome = 0; init(); window.__mtwHome = 1; });
})();
